<kt-portlet>
    <kt-portlet-header
            [title]="getComponentTitle() | async"
            [class]="'kt-portlet-head--lg'"
            [tooltipTitle]="'TOOLTIP.CLIENT.FORM'+(client && client.id > 0 ? '_EDIT':'')+'.TITLE' | translate"
            [tooltipDesc]="'TOOLTIP.CLIENT.FORM'+(client && client.id > 0 ? '_EDIT':'')+'.DESCRIPTION' | translate"
            [viewLoading$]="loading$">
        <ng-container ktPortletTools>
            <a (click)="back()"
               href="javascript:;"
               class="btn mr-2"
               mat-raised-button
               [matTooltip]="'GENERAL.TOOLTIP.BACK' | translate:{
                back_page: ('CLIENT.LIST.TITLE' | translate)
            }">
                <mat-icon>arrow_back</mat-icon>
                <span class="kt-hidden-mobile">{{ 'GENERAL.BUTTON.CLOSE' | translate }}</span>
            </a>
            <a *ngIf="canEdit$|async" href="javascript:;" class="btn btn-success mr-2" color="submit"
               (click)="onSubmit()"
               [disabled]="!isFormValid()"

               mat-raised-button [matTooltip]="'GENERAL.TOOLTIP.SAVE' | translate">
                <span class="kt-hidden-mobile">{{ 'GENERAL.BUTTON.SAVE' | translate }}</span>
            </a>
            <!--</mat-menu>-->
        </ng-container>
    </kt-portlet-header>

    <kt-portlet-body [ngClass]="{'readonly': !(canEdit$|async)}">
        <form class="form" *ngIf="client"  [formGroup]="clientForm">
            <div class="card-body">

                <!-- <kt-alert *ngIf="hasFormErrors" type="warn" [duration]="30000" [showCloseButton]="true" (close)="onAlertClose($event)">
                    {{ hasFormErrorsDesc}}
                </kt-alert> -->

                <div class="form-group kt-form-group row">
                    <div class="col-md-12 kt-margin-bottom-10-mobile">
                        <mat-radio-group formControlName="type" class="flex-row-radio-group" [(ngModel)]="client.type">
                            <mat-radio-button class="example-radio-button" value="Company">
                                {{ 'CLIENT.FORM.FIELD.GENERAL.CLIENT_TYPE.VALUE.COMPANY' | translate }}
                            </mat-radio-button>
                            <mat-radio-button class="example-radio-button" value="Individual">
                                {{ 'CLIENT.FORM.FIELD.GENERAL.CLIENT_TYPE.VALUE.INDIVIDUAL' | translate }}
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>

                <div class="form-group kt-form-group row" *ngIf="client.type === 'Company'">
                    <div class="col-lg-12 kt-margin-bottom-20-mobile">
                        <mat-form-field class="mat-form-field-fluid" [formFieldState]="clientForm.controls['name']">
                            <input matInput [placeholder]="'CLIENT.FORM.FIELD.GENERAL.CLIENT_NAME.PLACEHOLDER' | translate" formControlName="name"
                                   [(ngModel)]="client.name"
                            />
                            <mat-hint [formFieldHintState]="clientForm.controls['name']">
                                Client Name <span>required</span>
                            </mat-hint>
                            <mat-error
                                    [innerHtml]="'GENERAL.VALIDATION.REQUIRED' | translate:{
                                    field: ('CLIENT.FORM.FIELD.GENERAL.CLIENT_NAME.NAME' | translate)
                                }"
                            >
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="form-group kt-form-group row" *ngIf="client.type === 'Individual'">
                    <div class="col-lg-6 kt-margin-bottom-20-mobile">
                        <mat-form-field class="mat-form-field-fluid" [formFieldState]="clientForm.controls['name']">
                            <input matInput [placeholder]="'CLIENT.FORM.FIELD.GENERAL.FIRST_NAME.PLACEHOLDER' | translate" formControlName="name"
                                   [(ngModel)]="client.name"
                            />
                            <mat-hint [formFieldHintState]="clientForm.controls['name']">
                                Client First Name <span>required</span>
                            </mat-hint>
                            <mat-error
                                    [innerHtml]="'GENERAL.VALIDATION.REQUIRED' | translate:{
                                    field: ('CLIENT.FORM.FIELD.GENERAL.FIRST_NAME.NAME' | translate)
                                }"
                            >
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-lg-6 kt-margin-bottom-20-mobile">
                        <mat-form-field class="mat-form-field-fluid" [formFieldState]="clientForm.controls['last_name']">
                            <input matInput [placeholder]="'CLIENT.FORM.FIELD.GENERAL.LAST_NAME.PLACEHOLDER' | translate" formControlName="last_name"
                                   [(ngModel)]="client.last_name"
                            />
                            <mat-hint [formFieldHintState]="clientForm.controls['last_name']">
                                Client Last Name <span>required</span>
                            </mat-hint>
                            <mat-error
                                    [innerHtml]="'GENERAL.VALIDATION.REQUIRED' | translate:{
                                    field: ('CLIENT.FORM.FIELD.GENERAL.LAST_NAME.NAME' | translate)
                                }"
                            >
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-6 kt-margin-bottom-20-mobile">
                        <mat-form-field class="mat-form-field-fluid" [formFieldState]="clientForm.controls['phone']">
                            <input matInput
                                   type="tel"
                                   [placeholder]="'CLIENT.FORM.FIELD.GENERAL.PHONE.PLACEHOLDER' | translate"
                                   [(ngModel)]="client.phone"
                                   formControlName="phone"/>
                            <mat-hint [formFieldHintState]="clientForm.controls['phone']">
                                Client Phone <span>required</span>
                            </mat-hint>
                            <mat-error
                                    [innerHtml]="'GENERAL.VALIDATION.REQUIRED' | translate:{
                                       field: ('CLIENT.FORM.FIELD.GENERAL.PHONE.NAME' | translate)
                                   }"
                            >
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-6 kt-margin-bottom-20-mobile">
                        <mat-form-field class="mat-form-field-fluid" [formFieldState]="clientForm.controls['email']">
                            <input matInput
                                   type="email"
                                   [placeholder]="'CLIENT.FORM.FIELD.GENERAL.EMAIL.PLACEHOLDER' | translate"
                                   [(ngModel)]="client.email"
                                   formControlName="email"/>
                            <mat-hint [formFieldHintState]="clientForm.controls['phone']">
                                Client Email <span>required</span>
                            </mat-hint>
                            <mat-error *ngFor="let validation of validationMessages.email">
                                <mat-error class="error-message" *ngIf="clientForm.get('email').hasError(validation.type) && (clientForm.get('email').dirty || clientForm.get('email').touched)"
                                           [innerHtml]="'GENERAL.VALIDATION.CUSTOM_ERROR' | translate:{
                                        message: validation.message,
                                        decoration: validation.decorated
                                    }"
                                >
                                </mat-error>
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="form-group kt-form-group row">
                    <div class="col-lg-4 kt-margin-bottom-20-mobile">
                        <mat-form-field class="mat-form-field-fluid" [formFieldState]="clientForm.controls['country_id']">
                            <mat-select [placeholder]="'CLIENT.FORM.FIELD.GENERAL.COUNTRY.PLACEHOLDER' | translate" formControlName="country_id" [(ngModel)]="client.country_id"
                                        (selectionChange)="selectCountry()">
                                <mat-option>
                                    <ngx-mat-select-search [formControl]="countryFilterCtrl"
                                                           [placeholderLabel]="'GENERAL.PLACEHOLDER.SEARCH' | translate"
                                                           [noEntriesFoundLabel]="'GENERAL.MESSAGE.NOT_FOUND' | translate:{
                                                               entry: 'Country' 
                                                           } ">

                                    </ngx-mat-select-search>
                                </mat-option>
                                <mat-option>
                                    <div (click)="addCountry()" class="add-entry">
                                        <i class="ki ki-plus"></i> New country
                                    </div>
                                </mat-option>
                                <mat-option *ngFor="let country of countries" [value]="country.id">{{country.name}}</mat-option>
                            </mat-select>
                            <mat-hint [formFieldHintState]="clientForm.controls['country_id']">
                                Country <span>required</span>
                            </mat-hint>
                            <mat-error
                                    [innerHtml]="'GENERAL.VALIDATION.REQUIRED' | translate:{
                                    field: ('CLIENT.FORM.FIELD.GENERAL.COUNTRY.NAME' | translate)
                                }"
                            >
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-4 kt-margin-bottom-20-mobile">
                        <mat-form-field class="mat-form-field-fluid" [formFieldState]="clientForm.controls['city_id']">
                            <mat-select [placeholder]="'CLIENT.FORM.FIELD.GENERAL.CITY.PLACEHOLDER' | translate" formControlName="city_id" [(ngModel)]="client.city_id">
                                <mat-option>
                                    <ngx-mat-select-search [formControl]="cityFilterCtrl"
                                                           [placeholderLabel]="'GENERAL.PLACEHOLDER.SEARCH' | translate"
                                                           [noEntriesFoundLabel]="'GENERAL.MESSAGE.NOT_FOUND' | translate:{
                                                               entry: 'City' 
                                                           } ">

                                    </ngx-mat-select-search>
                                </mat-option>
                                <mat-option *ngIf="clientForm.controls.country_id.value">
                                    <div (click)="addCity()" class="add-entry">
                                        <i class="ki ki-plus"></i> New city
                                    </div>
                                </mat-option>
                                <mat-option *ngFor="let city of cities" [value]="city.id">{{city.name}}</mat-option>
                                <!--<mat-option *ngIf="client.country_id && cityOfCountry.length == 0" disabled>please add a city under *COUNTRY NAME* under the Localisation section</mat-option>-->
                                <mat-option *ngIf="cities.length == 0" disabled>{{ 'GENERAL.MESSAGE.NO_CITY' | translate }}</mat-option>
                            </mat-select>
                            <mat-hint [formFieldHintState]="clientForm.controls['city_id']">
                                City <span>required</span>
                            </mat-hint>
                            <mat-error
                                    [innerHtml]="'GENERAL.VALIDATION.REQUIRED' | translate:{
                                    field: ('CLIENT.FORM.FIELD.GENERAL.CITY.NAME' | translate)
                                }"
                            >
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-lg-4 kt-margin-bottom-20-mobile">
                        <mat-form-field class="mat-form-field-fluid">
                            <input matInput [placeholder]="'CLIENT.FORM.FIELD.GENERAL.ZIPCODE.PLACEHOLDER' | translate" [(ngModel)]="client.zip_code" formControlName="zip_code"/>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 kt-margin-bottom-10-mobile">
                        <mat-form-field class="mat-form-field-fluid">
                            <textarea matInput rows="2" [placeholder]="'CLIENT.FORM.FIELD.GENERAL.ADDRESS.PLACEHOLDER' | translate" formControlName="address"
                                      [(ngModel)]="client.address"
                            ></textarea>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <kt-contact-list
                    [(clientId)]="client.id"
                    [(clientName)]="client.name"
                    [readonly]="!(canEdit$|async)"
                    *ngIf="client.type == 'Company'"
            >
            </kt-contact-list>

            <mat-error 
                errorStateWithLength
                [hasFormError]="hasFormErrors"
                [isInValid]="client.type == 'Company' && this.contactComponent && this.contactComponent.contactData.length == 0"
                class="tag-custom-error mt-2" 
                [innerHtml]="'GENERAL.VALIDATION.REQUIRED' | translate:{
                    field: ('CLIENT.FORM.FIELD.GENERAL.CONTACTS.NAME' | translate)
                }"
            >
            </mat-error>

            <kt-reg-numbers-list
                *ngIf="client.type == 'Company'"
                [readonly]="!(canEdit$|async)"
                [(regNumbersSubject)]="regNumbersSubject">
            </kt-reg-numbers-list>
        </form>
    </kt-portlet-body>
</kt-portlet>

